import { render } from "./margin-summer-2025.vue?vue&type=template&id=ea4c6520"
import script from "./margin-summer-2025.js?vue&type=script&lang=js&external"
export * from "./margin-summer-2025.js?vue&type=script&lang=js&external"

import "./margin-summer-2025.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__